import { render, staticRenderFns } from "./movie.vue?vue&type=template&id=49dc7715&"
import script from "./movie.vue?vue&type=script&lang=js&"
export * from "./movie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports